.wrapper {
  border-radius: var(--mantine-radius-md);
  border: 1px dashed var(--mantine-color-gray-3);
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: var(--mantine-color-white);
  transition: all 0.2s ease;
}

.wrapper[data-error="true"] {
  border-color: var(--mantine-color-error);
  background-color: lighten(var(--mantine-color-error), 90%);
}

.wrapper[data-error="true"]:hover {
  cursor: pointer;
  background-color: lighten(var(--mantine-color-error), 80%);
}

.wrapper[data-error="false"] {
  border-color: var(--mantine-color-success);
  background-color: lighten(var(--mantine-color-success), 95%);
  color: var(--mantine-color-success) !important;
}

.wrapper[data-error="false"] .success > p {
  color: var(--mantine-color-green-9) !important;
  background-color: inherit;
}

.wrapper[data-error="false"]:hover {
  background-color: lighten(var(--mantine-color-primary), 75%);
  cursor: pointer;
}

.fileName {
  flex: 1;
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-gray-7);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fileSize {
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-gray-6);
}

.removeButton {
  stroke: var(--mantine-color-gray-4);
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
}

.removeButton:hover {
  opacity: 1;
}
